module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n5n9r3n-de281af8014712ca26721deb03364b91.svg";